import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'
import { get } from 'lodash'
import * as Accessa from 'accessa'
import {
  Box,
  Button,
  Container,
  Typography,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import Hero from './Hero'
import { getAsArray } from '../utils/helpers'

const ArchiveLayoutSubPages = ({ data }) => {
  const { t } = useTranslation('labels')
  return (
    <>
      <Hero {...data} />
      <Box bgcolor="background.default" pt={3} pb={6}>
        <Container maxWidth="md">
          <Typography variant="h2" align="center">
            {get(data, 'hero.subtitle')}
          </Typography>
        </Container>
      </Box>
      <Box bgcolor="background.paper" py={4}>
        <Container>
          {getAsArray(data, 'subPages')
            .filter((section) =>
              // only render those with hero images
              get(section, 'hero.image.fluid.src')
            )
            .map((section, i) => (
              <Box my={4} key={i}>
                <Accessa.Sections.Panel
                  swap={i % 2 === 0}
                  image={get(section, 'hero.image')}
                  title={get(section, 'hero.title')}
                  body={get(section, 'hero.subtitle')}
                >
                  <Button
                    component={Link}
                    variant="contained"
                    color="secondary"
                    to={get(section, 'relativePath', '/')}
                  >
                    {t('readMore')}
                  </Button>
                </Accessa.Sections.Panel>
              </Box>
            ))}
        </Container>
      </Box>
    </>
  )
}
ArchiveLayoutSubPages.propTypes = {
  data: PropTypes.shape({
    // eslint-disable-next-line
    hero: PropTypes.object,
    // eslint-disable-next-line
    subPages: PropTypes.array,
  }).isRequired,
}

export default ArchiveLayoutSubPages
